/**
 * @generated SignedSource<<7d461b53fcc291728dadd364fe2c164a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CastVoteInputVoteButtonsQueryFragment$data = {
  readonly delegate?: {
    readonly address: {
      readonly address: string;
    };
    readonly delegateSnapshot: {
      readonly nounsRepresented: ReadonlyArray<{
        readonly __typename: "Noun";
      }>;
    };
    readonly liquidRepresentation: ReadonlyArray<{
      readonly proxy: {
        readonly delegateSnapshot: {
          readonly nounsRepresented: ReadonlyArray<{
            readonly __typename: "Noun";
          }>;
        };
        readonly proposalVote: {
          readonly __typename: "Vote";
        } | null;
      };
    }>;
    readonly proposalVote: {
      readonly __typename: "Vote";
    } | null;
  };
  readonly " $fragmentType": "CastVoteInputVoteButtonsQueryFragment";
};
export type CastVoteInputVoteButtonsQueryFragment$key = {
  readonly " $data"?: CastVoteInputVoteButtonsQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CastVoteInputVoteButtonsQueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "proposalId",
    "variableName": "proposalId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": (v0/*: any*/),
  "concreteType": "DelegateSnapshot",
  "kind": "LinkedField",
  "name": "delegateSnapshot",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Noun",
      "kind": "LinkedField",
      "name": "nounsRepresented",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": (v0/*: any*/),
  "concreteType": "Vote",
  "kind": "LinkedField",
  "name": "proposalVote",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "kind": "RootArgument",
      "name": "proposalId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CastVoteInputVoteButtonsQueryFragment",
  "selections": [
    {
      "condition": "skipAddress",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "addressOrEnsName",
              "variableName": "address"
            }
          ],
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "delegate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "fields": [
                    {
                      "kind": "Literal",
                      "name": "canVote",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "currentlyActive",
                      "value": true
                    },
                    {
                      "fields": (v0/*: any*/),
                      "kind": "ObjectValue",
                      "name": "forProposal"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "filter"
                }
              ],
              "concreteType": "LiquidDelegationRepresentation",
              "kind": "LinkedField",
              "name": "liquidRepresentation",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Delegate",
                  "kind": "LinkedField",
                  "name": "proxy",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "bc03f686fa0f7a1455670a63d5cb72a0";

export default node;
